var lib_core = require("lib-core");
var PropValueData = require("./propValueData.js");

var PropValueUnitData = function (name, defaultValue, valueMin, valueMax, unit, defaultPrefix){
    PropValueData.call(this, name, defaultValue, valueMin, valueMax); // same value field as normal property

    this.unit = this.value("unit", true);
    this.defaultPrefix = this.value("defaultPrefix", true);

    if(unit) this.unit(unit);
    if(defaultPrefix) this.defaultPrefix(defaultPrefix);
};
lib_core.inherit(PropValueUnitData, PropValueData);
lib_core.JsonParser.registerClass(PropValueUnitData, "PropValueUnitData");

module.exports = PropValueUnitData;

PropValueUnitData.prototype.isFixedUnit = function(){
    return (this.defaultPrefix() == null);
};

PropValueUnitData.prototype.getUnitList = function(){
    if (this.isFixedUnit()) return null;

    var unit = (this.unit().toLowerCase() == 'ohm') ? '\u2126' : this.unit();   // TODO: do we want to convert ohm symbol here?
    return ['p', 'n', 'µ', 'm', '', 'k', 'M', 'G'].map(function(prefix){
        return [prefix + unit, prefix || 'none'];
    });
};
